export async function CreatingEvent(apiInstance, data) {
  try {
    const response = await apiInstance.post(`/event/create`, data);
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occured");
  }
}

export async function SearchEventsByParams(apiInstance, query) {
  try {
    const response = await apiInstance.get(`/Event/search?searchText=${query}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function GetEventsByEventId(apiInstance, eventId) {
  try {
    const response = await apiInstance.get(`/Event/${eventId}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function ViewEventsByMonth(apiInstance, month, year) {
  try {
    const response = await apiInstance.post(`/event/calendar`, {
      month: month,
      year: year,
    });
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function RegisterAthlete(
  apiInstance,
  eventId,
  userId,
  tShirtSize,
) {
  try {
    const data = {
      eventId: eventId,
      userId: userId,
      tShirtSize: tShirtSize,
    };
    const response = await apiInstance.post(`/event/register`, data);
    return response;
  } catch (err) {
    return err;
  }
}

// Event Update Feature
export async function UpdateEvent(apiInstance, eventId, eventData) {
  try {
    const response = await apiInstance.put(`/event/${eventId}`, eventData);
    return response;
  } catch (err) {
    return err;
  }
}

// Event Delete Feature
export async function DeleteEvent(apiInstance, eventId) {
  try {
    const response = await apiInstance.delete(`/event/${eventId}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

//attendees for an event
export async function getAttendees(apiInstance, eventId) {
  try {
    const response = await apiInstance.get(`/event/${eventId}/attendees`);
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : new Error("An error occurred while fetching attendees");
  }
}

export async function GetAdminPrice(apiInstance) {
  try {
    const response = await apiInstance.get(`/admin/pricing-options`);
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false };
  }
}
//Confirm the api deployment
export async function GetEventCombinePrice(apiInstance, eventId) {
  try {
    const response = await apiInstance.get(`payment/combine/${eventId}`);
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false };
  }
}

export async function getCombineBundleForEvent(apiInstance, eventId) {
  try {
    const response = await apiInstance.get(`payment/combine-bundle/${eventId}`);
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false };
  }
}

export async function SaveAppliedCouponCode(apiInstance, code) {
  try {
    const response = await apiInstance.put(`/payment/coupon-apply/${code}`);
    return response.data;
  } catch (err) {
    return { success: false };
  }
}

export async function GetEventAuditList(apiInstance, eventId) {
  try {
    const response = await apiInstance.get(`/event/${eventId}/audit-list`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}
